/**
 * Business-day date math for delivery estimates.
 *
 * The warehouse does not process orders on Saturday or Sunday.
 * Counting 2 days from Friday lands on Tuesday. Counting 2 days from
 * Saturday also lands on Tuesday, because the clock starts the next Monday.
 * A date that still falls on a weekend is pushed forward to Monday.
 *
 * Twin of `snippets/dev-business-days.liquid` and the range label in
 * `snippets/dev-format-delivery-range.liquid`. Keep them in step.
 */
(function (root) {
  const EN_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /**
   * @param {Date} date
   * @param {number} days
   * @returns {Date}
   */
  function addCalendarDays(date, days) {
    const next = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
    next.setDate(next.getDate() + days);
    return next;
  }

  /**
   * @param {Date} date
   * @returns {boolean}
   */
  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  /**
   * Saturday or Sunday moves to the following Monday. Weekdays stay put.
   *
   * @param {Date} date
   * @returns {Date}
   */
  function shiftOffWeekend(date) {
    const day = date.getDay();
    if (day === 6) return addCalendarDays(date, 2);
    if (day === 0) return addCalendarDays(date, 1);
    return addCalendarDays(date, 0);
  }

  /**
   * @param {Date} date
   * @param {number} days
   * @param {1 | -1} [direction]
   * @returns {Date}
   */
  function moveBusinessDays(date, days, direction = 1) {
    const count = Math.abs(days);
    const sign = direction < 0 ? -1 : 1;
    let cursor = addCalendarDays(date, 0);
    let left = count;

    while (left > 0) {
      cursor = addCalendarDays(cursor, sign);
      if (!isWeekend(cursor)) left -= 1;
    }

    return cursor;
  }

  /**
   * "Fri–Tue" or "28 Sep–2 Oct". End date is snapped off the weekend first.
   *
   * @param {Date} endDate
   * @param {string[]} [months]
   * @returns {string}
   */
  function formatDeliveryRange(endDate, months = EN_MONTHS) {
    const end = shiftOffWeekend(endDate);
    const start = moveBusinessDays(end, 2, -1);
    const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();

    if (sameMonth) {
      return `${start.getDate()}–${end.getDate()} ${months[end.getMonth()]}`;
    }

    return `${start.getDate()} ${months[start.getMonth()]}–${end.getDate()} ${months[end.getMonth()]}`;
  }

  root.NoomaBusinessDays = {
    shiftOffWeekend,
    moveBusinessDays,
    formatDeliveryRange,
  };
})(typeof window !== 'undefined' ? window : globalThis);
